import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../Services/AuthGard.service";
import { Subject, Subscription } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { timer } from 'rxjs/observable/timer'
declare var $;

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css']
})
export class PortalComponent implements OnInit {

  minutesDisplay = 0;
  secondsDisplay = 0;

  endTime = 30;

  unsubscribe$: Subject<void> = new Subject();
  timerSubscription: Subscription;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.resetTimer();
    this.authService.userActionOccured.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(() => {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
      this.resetTimer();
    });
  }

  resetTimer(endTime: number = this.endTime) {
    const interval = 1000;
    const duration = endTime * 60;
    this.timerSubscription = timer(0, interval).pipe(
      take(duration)
    ).subscribe(value =>
        this.render((duration - +value) * interval),
      err => { },
      () => {
        const theuser:any = JSON.parse(localStorage.getItem('currentUser'));
        if(theuser && theuser.token)
          this.authService.logout().subscribe( log =>{
            if(log.success){
              console.log("logout successfully")
            }
          });
      }
    )
  }

  private render(count) {
    this.secondsDisplay = this.getSeconds(count);
    this.minutesDisplay = this.getMinutes(count);
  }

  private getSeconds(ticks: number) {
    const seconds = ((ticks % 60000) / 1000).toFixed(0);
    return this.pad(seconds);
  }

  private getMinutes(ticks: number) {
    const minutes = Math.floor(ticks / 60000);
    return this.pad(minutes);
  }

  private pad(digit: any) {
    return digit <= 9 ? '0' + digit : digit;
  }

  toggleSidenav(){
    $('.text').toggle(280);
    $('.menu').toggleClass('width240');
    $('.menu').toggleClass('width90');
    $('.main').toggleClass('marginLft70');
    $('.leftArrow').toggleClass('rightArrow');
    $('.rightArrowAlign').toggleClass('leftArrowAlign');
    $('.submenu-body').toggleClass('submneu-nopadding');
  }


  toggleMenuSub(){
    $('.subArrow').toggleClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
    $('.portalReportArrow').removeClass("portalReportArrowRotate");
    $('.localizationArrow').removeClass("localizationArrowRotate");
  }

  toggleMenuCommu(){
    $('.commuArrow').toggleClass("commuArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
    $('.portalReportArrow').removeClass("portalReportArrowRotate");
    $('.localizationArrow').removeClass("localizationArrowRotate");
  }

  toggleMenuPortal(){
    $('.portalArrow').toggleClass("portalArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
    $('.portalReportArrow').removeClass("portalReportArrowRotate");
    $('.localizationArrow').removeClass("localizationArrowRotate");
  }

 toggleMenuContent(){
    $('.contentAdminArrow').toggleClass("contentArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
   $('.portalArrow').removeClass("portalArrowRotate");
   $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
   $('.portalReportArrow').removeClass("portalReportArrowRotate");
   $('.localizationArrow').removeClass("localizationArrowRotate");
  }

  toggleMenuAuthor(){
    $('.gameAuthArrow').toggleClass("gameAuthArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.portalReportArrow').removeClass("portalReportArrowRotate");
    $('.localizationArrow').removeClass("localizationArrowRotate");
  }

  toggleMenuPortalReports(){
    $('.portalReportArrow').toggleClass("portalReportArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.localizationArrow').removeClass("localizationArrowRotate");
  }

  localizationData(){
    $('.localizationArrow').toggleClass("localizationArrowRotate");
    $('.gameAuthArrow').removeClass("gameAuthArrowRotate");
    $('.contentAdminArrow').removeClass("contentArrowRotate");
    $('.subArrow').removeClass("subArrowRotate");
    $('.commuArrow').removeClass("commuArrowRotate");
    $('.portalArrow').removeClass("portalArrowRotate");
    $('.portalReportArrow').removeClass("portalReportArrowRotate");
  }


}



// WEBPACK FOOTER //
// ./src/app/Screens/portal/portal.component.ts